import AddSvg from '../assets/img/svg/add'
// import PresetSvg from '../assets/img/svg/preset'

const TopBar = ({ callback, callbackPreset }) => {
  return (
    <div className="top-bar">
      <h2>Service bundles</h2>
      <div className="top-bar-flex">
        {/* <div
          className="top-bar-btn-preset"
          onClick={() => {
            // callbackPreset(true)
          }}
        >
          <PresetSvg />
          <span>Preset</span>
        </div> */}
        <div className="top-bar-btn" onClick={() => callback(true)}>
          <AddSvg />
          <span>New bundle</span>
        </div>
      </div>
    </div>
  )
}

export default TopBar
